import { Layout, Typography } from 'antd';

const { Footer } = Layout;
const { Text } = Typography;

export default function AdminFooter() {
  return (
    <Footer
      style={{
        padding: '16px 24px',
        background: 'transparent',
        textAlign: 'center',
      }}
    >
      <Text type="secondary" style={{ fontSize: 12 }}>
        © {new Date().getFullYear()} 南迴永續旅行聯盟 · SDGs 自評系統後台
      </Text>
    </Footer>
  );
}
